import { render, staticRenderFns } from "./TagAssignment.vue?vue&type=template&id=35ff38de&scoped=true&"
import script from "./TagAssignment.vue?vue&type=script&lang=js&"
export * from "./TagAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff38de",
  null
  
)

export default component.exports